export default __webpack_public_path__ + "static/Logo-70d9a31b3164ef5e28b347e37d4c300f.png";